var Freezer = require('./src/freezer');
module.exports = Freezer;


//////////////////
// WEBPACK FOOTER
// ./~/freezer-js/freezer.js
// module id = 549
// module chunks = 0